var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 3.5,
    fill: "#EFEBFE",
    stroke: "#8D6CFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 19H19V11H11V19ZM13 13H17V17H13V13ZM21 29H29V21H21V29ZM23 23H27V27H23V23ZM11 29H19V21H11V29ZM13 23H17V27H13V23ZM21 11V19H29V11H21ZM27 17H23V13H27V17Z",
    fill: "#8D6CFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridPurple);
export default __webpack_public_path__ + "static/media/grid-purple.db6f75e64ad9728ca47a0ee06a56f2c3.svg";
export { ForwardRef as ReactComponent };